import { createFileRoute } from '@tanstack/react-router';
import { LotteryEmbedPage } from '../features/games/LotteryEmbedPage.js';

// Deep-linkable lottery board: /lottery/yeekee_84 launches that game directly.
export const Route = createFileRoute('/_player/lottery/$code')({
  component: LotteryGameRoute,
});

function LotteryGameRoute() {
  const { code } = Route.useParams();
  return <LotteryEmbedPage view={{ kind: 'game', code }} />;
}
